/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Faq_Delete_AInputs */



/**
* | output |
* | --- |
* | "Not yourself yet. Contact your oneAI partner manager and we will take care of it." |
*
* @param {Partner_Faq_Delete_AInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_faq_delete_a = /** @type {((inputs?: Partner_Faq_Delete_AInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Faq_Delete_AInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch nicht selbst. Wenden Sie sich an Ihren oneAI-Partnermanager, wir kümmern uns darum.")
	return /** @type {LocalizedString} */ ("Not yourself yet. Contact your oneAI partner manager and we will take care of it.")
});